import { render, staticRenderFns } from "./NovoRegistroRemotoPage.vue?vue&type=template&id=7ac26dc8&scoped=true"
import script from "./NovoRegistroRemotoPage.vue?vue&type=script&lang=js"
export * from "./NovoRegistroRemotoPage.vue?vue&type=script&lang=js"
import style0 from "./NovoRegistroRemotoPage.vue?vue&type=style&index=0&id=7ac26dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac26dc8",
  null
  
)

export default component.exports